import { Modal } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const deviceStatusToFields = (deviceStatus) => {
    return {
        "bloqueadorEmbutido": deviceStatus.bloqueador,
        "bloqueioRemocaoSimCard": deviceStatus.remSimcard,
        "bloqueioRemocaoRastreador": deviceStatus.faltaStt,
        "bloqueioID": deviceStatus.idRastreador,
        "bloqueioTipo": deviceStatus.tipoBlk === 0 ? "seguro" : "progressivo",
        "bloqueioTempo": deviceStatus.tempoPresenca / 10,
        "roteirizador": deviceStatus.roteirizador[0] === "1",
        "senhaIgnicaoInput1": deviceStatus.senhaIgnicao.toString()[0],
        "senhaIgnicaoInput2": deviceStatus.senhaIgnicao.toString()[1],
        "jamming": deviceStatus.jamming[0] === "1",
        "sensiJamming": parseInt(deviceStatus.jamming.substring(1, 3)),
        "controleParada": deviceStatus.controleParada.toString() === "1",
        "controleParadaTempo": deviceStatus.tempoParada / 10
    };
}

export const deviceStatusFields = (plateName, formDeviceConfig, deviceStatus) => {
    const getValue = (field) => {
        return formDeviceConfig.getFieldValue(field);
    }

    return {
        "plate": plateName,
        "bloqueador": getValue("bloqueadorEmbutido") ? 1 : 0,
        "tempoPresenca": getValue("bloqueioTempo") * 10,
        "jamming": getValue("jamming") ? "1" + getValue("sensiJamming") : "0" + getValue("sensiJamming"),
        "senhaIgnicao": getValue("senhaIgnicaoInput1").toString() + getValue("senhaIgnicaoInput2").toString(),
        "roteirizador": getValue("roteirizador") ? 1 : 0,
        "controleParada": getValue("controleParada") ? 1 : 0,
        "tempoParada": getValue("controleParadaTempo") * 10,
        "tipoBlk": getValue("bloqueioTipo") === "seguro" ? 0 : 1,
        "idRastreador": getValue("bloqueioID") ? 1 : 0,
        "remSimcard": getValue("bloqueioRemocaoSimCard") ? 1 : 0,
        "faltaStt": getValue("bloqueioRemocaoRastreador") ? 1 : 0,
        "jammingStatus": deviceStatus && deviceStatus.jammingStatus ? parseInt(String(deviceStatus.jammingStatus).charAt(0)) : 0
    }
}

export const modalConfirm = ( formDeviceConfig, bloqueioProgressivo, desbloqueioProgressivo) => {
    return Modal.confirm({
        title: 'ATENÇÃO!',
        icon: <ExclamationCircleOutlined />,
        content: "A Everlink recomenda expressamente a adoção do ‘Bloqueio Seguro’, em conformidade com a legislação vigente, " +
            "e não se responsabiliza, em hipótese alguma, por quaisquer danos materiais e corporais (próprios ou a terceiros), " +
            "decorrentes do uso do bloqueio veicular." +
            "Caso, ainda assim, opte pelo ‘Bloqueio Progressivo’, há uma assunção expressa de sua parte quanto aos riscos envolvidos" +
            "e responsabilidades ora assumidas.",
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk: () => {
            desbloqueioProgressivo();
            formDeviceConfig.setFieldsValue({
                "bloqueioTipo": "progressivo"
            });
        },
        onCancel: () => {
            bloqueioProgressivo();
            formDeviceConfig.setFieldsValue({
                "bloqueioTipo": "seguro"
            });
        },

        width: 750,
        zIndex: 9999999
    });
}